import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';

export const ADD_ATTACHMENTS_MUTATION = gql`
  mutation Eager_addAttachments($input: AddAttachmentsInput!) {
    addAttachments(input: $input) {
      binaryObjectUris
    }
  }
`;

const useAddAttachment = () => {
  const [addAttachmentsMutation] = useMutation(ADD_ATTACHMENTS_MUTATION, {
    errorPolicy: 'all'
  });

  return async ({ correlatedObjectUri, files }) => {
    try {
      const { data, errors } = await addAttachmentsMutation({
        variables: { input: { correlatedObjectUri, files } }
      });

      if (errors?.[0]) return [errors[0], null];

      return [null, data?.addAttachments?.binaryObjectUris ?? []];
    } catch (err) {
      return [err, null];
    }
  };
};

export default useAddAttachment;
